/**
 * Self-contained build-time feature flag for the Follower Feed (Wheel-as-a-Room
 * rung 3). Kept in its own file (mirrors LinkedWheels/featureFlag.js,
 * gradientBuilder/featureFlag.js) so it can be reviewed/merged independently of
 * the parallel branches that also touch src/constants/featureFlags.js.
 *
 * Defaults OFF; flipped per environment via REACT_APP_FOLLOWER_FEED. When OFF the
 * "Following" feed route + nav entry are never rendered and the follower-feed API
 * route is never called — behaviour is byte-identical to today. Pairs with the
 * backend settings.FOLLOWER_FEED_ENABLED (which 404s the route while OFF), so a
 * half-flipped state degrades safely.
 *
 * At merge this can be folded into src/constants/featureFlags.js.
 */
const truthy = (v) => v === "true" || v === "1" || v === true;

export const FOLLOWER_FEED_ENABLED = truthy(process.env.REACT_APP_FOLLOWER_FEED);
